import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { SelectedWorkSection } from './components/SelectedWorkSection';
import { PrivateProfileSection } from './components/PrivateProfileSection';
import { PortfolioSection } from './components/PortfolioSection';
import { PortfolioGate, PORTFOLIO_ACCESS_SESSION_KEY } from './components/PortfolioGate';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { MouseFollower } from './components/MouseFollower';
import './index.css';
export function App() {
  const [isPortfolioUnlocked, setIsPortfolioUnlocked] = useState(() => typeof window !== 'undefined' && window.sessionStorage.getItem(PORTFOLIO_ACCESS_SESSION_KEY) === 'granted');
  const [isPortfolioGateOpen, setIsPortfolioGateOpen] = useState(false);
  const handlePortfolioUnlock = () => {
    window.sessionStorage.setItem(PORTFOLIO_ACCESS_SESSION_KEY, 'granted');
    setIsPortfolioUnlocked(true);
    setIsPortfolioGateOpen(false);
    window.setTimeout(() => {
      document.getElementById('private-profile')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 150);
  };
  return <>
      <main className="min-h-screen w-full bg-dark" data-id="element-0" data-mp="2znfyebhrc4op">
        <MouseFollower data-id="element-1" data-mp="33ngee0ki8nxv" />
        <Navbar isPortfolioUnlocked={isPortfolioUnlocked} onRequestPortfolioAccess={() => setIsPortfolioGateOpen(true)} data-id="element-2" data-mp="33myjb79kwfrj" />
        <HeroSection isPortfolioUnlocked={isPortfolioUnlocked} onRequestPortfolioAccess={() => setIsPortfolioGateOpen(true)} data-id="element-3" data-mp="3dl4mrtb19tyi" />
        <AboutSection data-id="element-4" data-mp="nxn53r85d1mu" />
        <ServicesSection data-id="element-5" data-mp="sudl6ejybx89" />
        <SelectedWorkSection data-id="element-6" data-mp="stubfl4ggf5b" />
        {isPortfolioUnlocked && <>
            <PrivateProfileSection data-id="element-7" data-mp="35ypel6klo1z" />
            <PortfolioSection data-id="element-8" data-mp="34x1vh8db93d" />
          </>}
        <TestimonialsSection data-id="element-9" data-mp="3ud1ftael3qb5" />
        <ContactSection data-id="element-10" data-mp="3ubrhql7qei4i" />
        <Footer data-id="element-11" data-mp="3ucjcjtti8btq" />
      </main>

      <PortfolioGate isOpen={isPortfolioGateOpen} onClose={() => setIsPortfolioGateOpen(false)} onUnlocked={handlePortfolioUnlock} data-id="element-12" data-mp="d4nvlgp3tk2e" />
    </>;
}